import * as React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Divider from '@material-ui/core/Divider'
import Hidden from '@material-ui/core/Hidden'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Done from '@material-ui/icons/Done'
import Update from '@material-ui/icons/Update'

import { Process, ProcessStatus } from '../../api'
import { success, percentageProcessTable, percentageProcessTableNumber } from '../../theme'
import { memoize } from '../../utils'
import loadable from '../hocs/loadable'


interface PercentageGraphic {
  percentage: number
}

const statusToIconMap = {
  [ProcessStatus.Done]: <Done nativeColor={success.main} />,
  [ProcessStatus.Ongoing]: <Update />,
}

const PorcentageNumber = styled.span`
  color: ${percentageProcessTableNumber};
  /* mix-blend-mode: difference; */
`

const PercentageGraphic = styled.div`
  background: ${({ percentage }: PercentageGraphic) => `linear-gradient(to right, ${percentageProcessTable} ${percentage}%, transparent 0%)`};
  border: solid 1px black;
  height: 80%;
  text-align: center;
  width: 80%;
`;

const calculatePercentage = ({ sessions, doneSessions }) => doneSessions * 100 / sessions

const ProcessTableRow = ({
  process,
  onClick,
  enumeration,
  info
}) => {
  const { student, teacher, status } = process

  const studentDisplay =
    student.active
      ? student.name
      : student.email

  const teacherDisplay =
    teacher.active
      ? teacher.name
      : teacher.email
  const percentage = info ? calculatePercentage(info) : 0
  return (
    <TableRow
      hover
      key={process.id}
      onClick={onClick}
      className={'cursor-pointer'}
    >
      <TableCell>{enumeration}</TableCell>
      <TableCell>{teacherDisplay}</TableCell>
      <TableCell>{studentDisplay}</TableCell>
      <TableCell numeric>
        <Hidden smDown>
          {info && info.doneSessions > 0 && <FormattedMessage id={`project.${status}`} />}
          {info && info.doneSessions <= 0 && <FormattedMessage id={`project.pending`} />}
        </Hidden>
        <Hidden mdUp>
          {statusToIconMap[status]}
        </Hidden>
      </TableCell>
      <TableCell>
        {info && `${info.doneSessions} / ${info.sessions}`}
      </TableCell>
      <TableCell style={{ paddingRight: 0 }}>
        <PercentageGraphic percentage={percentage}>
          <PorcentageNumber>
            {/* typescript SHIT */}
            {parseInt('' + percentage)}%
          </PorcentageNumber>
        </PercentageGraphic>
      </TableCell>
    </TableRow>
  )
}

interface ProcessTableProps {
  processes: Process[]
  onProcessClick: (programId: number) => void
  processesInfo: object
}
interface ProcessTableState {
  sortBy: string
}

class ProcessTable extends React.Component<ProcessTableProps, ProcessTableState> {
  constructor(props) {
    super(props)
    this.state = {
      sortBy: ''
    }
  }

  private onProcessClick = memoize(processId => () => {
    this.props.onProcessClick(processId)
  })

  public render() {
    const phrasing = {
      process: <FormattedMessage id={'project.process'} />,
      processes: <FormattedMessage id={'project.processes'} />,
      mentor: <FormattedMessage id={'project.mentor'} />,
      mentee: <FormattedMessage id={'project.mentee'} />,
      coach: <FormattedMessage id={'project.coach'} />,
      coachee: <FormattedMessage id={'project.coachee'} />,
      percentage: <FormattedMessage id={'project.executionPercentage'} />,
      status: <FormattedMessage id={'dictionary.status'} />,
    }

    const { processes, processesInfo } = this.props
    return (
      <Card>
        <CardHeader title={phrasing.processes} />
        <Divider />
        <div style={{ width: '100$', overflowX: 'auto' }}>
          <Table style={{ minWidth: 600 }}>
            <TableHead>
              <TableRow>
                <TableCell>
                  {phrasing.process}
                </TableCell>
                <TableCell>
                  <div style={{ cursor: 'pointer' }} onClick={() => {
                    switch (this.state.sortBy) {
                      case 'mentor':
                        this.setState({ sortBy: 'mentorreverse' })
                        break
                      case '':
                        this.setState({ sortBy: 'mentor' })
                        break
                      default:
                        this.setState({ sortBy: '' })
                    }
                  }}>
                    {phrasing.mentor}
                    {' '}
                    {this.state.sortBy === 'mentor' && '↓'}
                    {this.state.sortBy === 'mentorreverse' && '↑'}
                  </div>
                </TableCell>
                <TableCell>
                  <div style={{ cursor: 'pointer' }} onClick={() => {
                    switch (this.state.sortBy) {
                      case 'mentee':
                        this.setState({ sortBy: 'menteereverse' })
                        break
                      case '':
                        this.setState({ sortBy: 'mentee' })
                        break
                      default:
                        this.setState({ sortBy: '' })
                    }
                  }}>
                    {phrasing.mentee}
                    {' '}
                    {this.state.sortBy === 'mentee' && '↓'}
                    {this.state.sortBy === 'menteereverse' && '↑'}
                  </div>
                </TableCell>
                <TableCell numeric>
                  <div style={{ cursor: 'pointer' }} onClick={() => {
                    switch (this.state.sortBy) {
                      case '':
                        this.setState({ sortBy: 'status' })
                        break
                      case 'status':
                        this.setState({ sortBy: 'statusreverse' })
                        break
                      default:
                        this.setState({ sortBy: '' })
                    }
                  }}>
                    {phrasing.status}
                    {' '}
                    {this.state.sortBy === 'status' && '↓'}
                    {this.state.sortBy === 'statusreverse' && '↑'}
                  </div>
                </TableCell>
                <TableCell>
                  <div style={{ cursor: 'pointer' }} onClick={() => {
                    switch (this.state.sortBy) {
                      case '':
                        this.setState({ sortBy: 'sessions' })
                        break
                      case 'sessions':
                        this.setState({ sortBy: 'sessionsreverse' })
                        break
                      default:
                        this.setState({ sortBy: '' })
                    }
                  }}>
                    <span>Número de sesiones</span>
                    <br></br>
                    <span>realizadas / totales</span>
                    {' '}
                    {this.state.sortBy === 'sessions' && '↓'}
                    {this.state.sortBy === 'sessionsreverse' && '↑'}
                  </div>
                </TableCell>
                <TableCell numeric>
                  <div style={{ cursor: 'pointer' }} onClick={() => {
                    switch (this.state.sortBy) {
                      case '':
                        this.setState({ sortBy: 'percentage' })
                        break
                      case 'percentage':
                        this.setState({ sortBy: 'percentagereverse' })
                        break
                      default:
                        this.setState({ sortBy: '' })
                    }
                  }}>
                    {phrasing.percentage}
                    {' '}
                    {this.state.sortBy === 'percentage' && '↓'}
                    {this.state.sortBy === 'percentagereverse' && '↑'}
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(processes as any).sort((a, b) => {
                const { student: studentA, teacher: teacherA } = a
                const { student: studentB, teacher: teacherB } = b
                const studentDisplayA = studentA.active ? studentA.name : studentA.email
                const teacherDisplayA = teacherA.active ? teacherA.name : teacherA.email
                const studentDisplayB = studentB.active ? studentB.name : studentB.email
                const teacherDisplayB = teacherB.active ? teacherB.name : teacherB.email
                switch (this.state.sortBy) {
                  case 'mentee':
                    if (studentDisplayA < studentDisplayB) return -1;
                    if (studentDisplayA > studentDisplayB) return 1;
                    return 0
                  case 'menteereverse':
                    if (studentDisplayB < studentDisplayA) return -1;
                    if (studentDisplayB > studentDisplayA) return 1;
                    return 0
                  case 'mentor':
                    if (teacherDisplayA < teacherDisplayB) return -1;
                    if (teacherDisplayA > teacherDisplayB) return 1;
                    return 0
                  case 'mentorreverse':
                    if (teacherDisplayB < teacherDisplayA) return -1;
                    if (teacherDisplayB > teacherDisplayA) return 1;
                    return 0
                  case 'status':
                    if (a.status < b.status) return -1;
                    if (a.status > b.status) return 1;
                    return 0
                  case 'statusreverse':
                    if (b.status < a.status) return -1;
                    if (b.status > a.status) return 1;
                    return 0
                  case 'sessions':
                    if (processesInfo[a.id].doneSessions < processesInfo[b.id].doneSessions) return -1;
                    if (processesInfo[a.id].doneSessions > processesInfo[b.id].doneSessions) return 1;
                    return 0
                  case 'sessionsreverse':
                    if (processesInfo[b.id].doneSessions < processesInfo[a.id].doneSessions) return -1;
                    if (processesInfo[b.id].doneSessions > processesInfo[a.id].doneSessions) return 1;
                    return 0
                  case 'percentage':
                    if (calculatePercentage(processesInfo[a.id]) < calculatePercentage(processesInfo[b.id])) return -1;
                    if (calculatePercentage(processesInfo[a.id]) > calculatePercentage(processesInfo[b.id])) return 1;
                    return 0
                  case 'percentagereverse':
                    if (calculatePercentage(processesInfo[b.id]) < calculatePercentage(processesInfo[a.id])) return -1;
                    if (calculatePercentage(processesInfo[b.id]) > calculatePercentage(processesInfo[a.id])) return 1;
                    return 0
                  default:
                    return 1;
                }
              }).map((process, i) =>
                <ProcessTableRow
                  key={process.id}
                  process={process}
                  enumeration={i + 1}
                  info={processesInfo[process.id]}
                  onClick={this.onProcessClick(process.id)}
                />
              )}
            </TableBody>
          </Table>
        </div>
      </Card>
    )
  }
}

export default loadable(ProcessTable)



// WEBPACK FOOTER //
// ./src/components/molecules/ProcessTable.tsx